var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-featured-tours" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "featured-tours-list" },
      _vm._l(_vm.tours, function(tour, tdx) {
        return _c(
          "div",
          {
            key: "tour-option-" + tdx,
            staticClass: "featured-tour",
            class: { active: tour == _vm.activeTour },
            on: {
              mouseenter: function($event) {
                return _vm.enterTour(tour)
              },
              mouseleave: function($event) {
                return _vm.leaveTour(tour)
              }
            }
          },
          [
            _c(
              "a",
              {
                staticClass: "featured-tour-image",
                attrs: { href: tour.permalink }
              },
              [
                _c("img", {
                  attrs: { src: tour.details.image.sizes.medium_large }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "featured-tour-body" }, [
              _c("h5", {
                domProps: { innerHTML: _vm._s(tour.details.headline) }
              }),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "tour-title", attrs: { href: tour.permalink } },
                [_c("h4", { domProps: { innerHTML: _vm._s(tour.post_title) } })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "stop-details" }, [
                _vm._v(
                  _vm._s(tour.days.length) +
                    " DAYS | " +
                    _vm._s(tour.stops.length) +
                    " STOPS"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "featured-tour-description" }, [
                _vm._v(_vm._s(_vm._f("stripHtml")(tour.details.description)))
              ]),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "view-tour", attrs: { href: tour.permalink } },
                [_vm._v("view tour")]
              )
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home-section-header" }, [
      _c("h3", [_vm._v("tours")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/FeaturedTours.vue?vue&type=template&id=06b3ce5f&
// module id = 458
// module chunks = 0